import React, { useCallback } from "react";
import getMinutes from "date-fns/get_minutes";
import differenceInMinutes from "date-fns/difference_in_minutes";
//
import Screen from "./ConnectedScreen";
import TimePicker from "../components/TimePicker";
import Alert from "../components/Alert";
import PremiumAlert from "./PremiumAlert";

function getStep(date, minDate) {
  const diff = differenceInMinutes(date, minDate);
  const minutes = getMinutes(date);

  const isLast = diff >= 120;
  const isPreLast = diff === 105;
  const isHalve = minutes === 0 || minutes === 30;

  const isFar = isLast || (isPreLast && isHalve);

  return isFar ? 30 : 15;
}

function TimeScreen({
  breadcrumbs,
  date,
  isPremium,
  timeZone,
  minDate,
  isTimeMin,
  isBeforeTimeMin,
  isTimeMax,
  isAfterTimeMax,
  setTime,
  goTo,
  isComplimentaryCity,
}) {
  const goToDuration = useCallback(() => goTo("duration"));
  const step = getStep(date, minDate);

  const isDisabled = isBeforeTimeMin || isAfterTimeMax;

  return (
    <Screen
      title="Select time"
      isActive
      breadcrumbs={breadcrumbs}
      nextDisabled={isDisabled}
      onNext={goToDuration}
    >
      <TimePicker
        error={isDisabled ? "Invalid time" : null}
        value={date}
        onChange={setTime}
        timeZone={timeZone}
        mined={isTimeMin}
        maxed={isTimeMax}
        step={step}
      />
      {isTimeMax &&
        (isPremium || isComplimentaryCity ? (
          <div className="u-mt-large">
            <Alert
              warning
              text="Bookings **more than 72h in advance** is not possible."
            />
          </div>
        ) : (
          <div className="u-mt-large">
            <PremiumAlert text="_Premium members_ can book up to **72hours in advance** in advance." />
          </div>
        ))}
    </Screen>
  );
}

// @connect
import { bindActionCreators as bindActions } from "redux";
import { connect } from "react-redux";
import { setTimeAction } from "../modules/booking/actions";
import {
  isDateMin,
  isDateMax,
  isBeforeDateMin,
  isAfterDateMax,
  getCity,
  isPremiumIn,
  isComplimentaryCity,
} from "../selectors";

const props = (state) => {
  const { booking } = state;
  const { date, minDate } = booking;
  const city = getCity(state);

  return {
    date,
    minDate,
    isTimeMin: isDateMin(state),
    isBeforeTimeMin: isBeforeDateMin(state),
    isTimeMax: isDateMax(state),
    isAfterTimeMax: isAfterDateMax(state),
    isPremium: isPremiumIn(state),
    timeZone: city.timezone,
    isComplimentaryCity: isComplimentaryCity(state),
  };
};

const actions = (dispatch) =>
  bindActions(
    {
      setTime: setTimeAction,
    },
    dispatch
  );

export default connect(props, actions)(TimeScreen);
